import { NavLink } from "reactstrap";
import styled from "styled-components";

const HeaderNavLink = styled(NavLink)`
  color: #0078A8;
  &:hover {
    color: #0078A8;
  }
  padding: 0!important;
  text-align: left;
`;


export default HeaderNavLink;
